import React from 'react'
import { Button } from '~/components/_atoms'
import ChatHeader from '../ChatHeader'
import { useTranslation } from '~/hooks/useTranslation'
import { useCandidateChat } from '../CandidateChatContext'
import { getEffectiveExitUrl } from '../utils/getEffectiveExitUrl'

/**
 * CallCancelled component - displays when candidate cancels chat before coach accepts
 * Simple view with just an exit button, no survey or other content
 */
const CallCancelled = ({ afterChatPath }) => {
  const { t } = useTranslation('coach_chat')
  const { getDarkModeClasses, connectionState } = useCandidateChat()

  // Handle exit button click - when in video_chat_frame, go to #chat_browse URL
  const handleExit = () => {
    window.top.location.href = getEffectiveExitUrl(afterChatPath)
  }

  return (
    <div
      className={`call-cancelled-container grid h-screen w-full grid-rows-[auto_1fr_auto] border ${getDarkModeClasses('border-cod-gray-200 bg-white', 'border-gray-600 bg-gray-800')}`}
    >
      {/* Header */}
      <div className="call-cancelled-header row-start-1">
        <ChatHeader
          selectedCoach={connectionState.selectedCoach}
          chatMode={connectionState.chatMode || 'text'}
          chatStatus="call_cancelled"
          showControls={false}
        />
      </div>

      {/* Main Content - Empty space */}
      <div
        className={`call-cancelled-content row-start-2 ${getDarkModeClasses('bg-white', 'bg-gray-800')}`}
      />

      {/* Action Button - Docked to bottom */}
      <div
        className={`call-cancelled-actions border-t p-6 ${getDarkModeClasses('border-cod-gray-200 bg-white', 'border-gray-600 bg-gray-800')}`}
      >
        <Button
          variant="outline"
          color="secondary"
          size="md"
          fullWidth
          onClick={handleExit}
          className="h-10 rounded-2xl px-6"
        >
          {t('call_cancelled.exit', { defaultValue: 'Exit' })}
        </Button>
      </div>
    </div>
  )
}

export default CallCancelled
